import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';


@Injectable({
  providedIn: 'root'
})
export class TaskDataService extends ExcTranslation {

  Task = {

    Accept: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKACCEPT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang anzunehmen.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Accept', {vorgID: data.vorgID})
        , data, 'TaskAccept-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang wurde angenommen', 'md-toast', 'fal fa-check');
          }
        }));

    },
    Cancel: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKCANCEL')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang zu stornieren.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Cancel', {vorgID: data.vorgID})
        , data, 'TaskCancel-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang storniert', 'md-toast', 'fal fa-check');
          }
        }));
    },
    Check: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKCHECK')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang als geprüft zu markieren', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      const subData = {auCHK: true};
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Check', {vorgID: data.vorgID})
        , subData, 'TaskCheck-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang als geprüft markiert', 'md-toast', 'fal fa-check');
            return response;
          }
        }));
    },
    Decline: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKDECLINE')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang abzulehnen.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Decline', {vorgID: data.vorgID})
        , data, 'TaskDecline-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang wurde abgelehnt', 'md-toast', 'fal fa-check');
          }
        }));

    },
    Finish: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKFINISH')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang fertig zu melden.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Finish', {vorgID: data.vorgID})
        , data, 'TaskFinish-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang fertig gemeldet', 'md-toast', 'fal fa-check');
          }
        }));
    },
    SendToQS: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKFINISH')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang an QS zu senden.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFSendToQS', {vorgID: data.vorgID})
        , data, 'WFSendToQS-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang an QS gesendet', 'md-toast', 'fal fa-check');
          }
        }));
    },
    FinalFinish: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKFINALFINISH') || !this.excSecurity.isFeatured('TASKFINALFINISH')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang abzuschließen.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_FinalComplete', {vorgID: data.vorgID})
        , {vorgUPT: data.vorgUPT}, 'TaskU_FinalComplete-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang abgeschlossen', 'md-toast', 'fal fa-check');
          }
        }));
    },
    QSReturn: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKFINISH')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang zurück zur Bearbeitung zu geben.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFQSReturn', {vorgID: data.vorgID})
        , data, 'WFQSReturn-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang zur Bearbeitung zurückgegeben', 'md-toast', 'fal fa-check');
          }
        }));
    },
    QSRegFinish: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKQSREGFINISH')) {
        this.modal.showToast('Sie sind nicht berechtigt diese Aktion auszuführen.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFQSRegFinish', {vorgID: data.vorgID})
        , data, 'WFQSRegFinish-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Regulierungsvereinbarung / QS abgeschlossen', 'md-toast', 'fal fa-check');
          }
        }));
    },
    InitSchedule: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('SCHEDULEINIT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Ablaufplan zu initialisieren', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFInitSchedule', {vorgID: data.vorgID})
        , data, 'InitSchedule-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Ablaufplan für den Vorgang wurde initialisiert', 'md-toast', 'fal fa-check');
          }
        }));
    },
    SendToApp: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASK2APP')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang an die App zu senden', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFSendToApp', {vorgID: data.vorgID})
        , data, 'SendToApp-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang wurde an die App gesendet', 'md-toast', 'fal fa-check');
          }
        }));
    },
    ContactAttempt: (data: any, dataCase: any, contactDetails?: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKCONTATTEMPT')) {
        this.modal.showToast('Sie sind nicht berechtigt einen Kontaktaufnahmeversuch zu protokollieren', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }

      const requestData = contactDetails ? {
        ...data,
        contactDateTime: new Date(contactDetails.contactDateTime).toISOString(),
        comment: contactDetails.comment
      } : data;

      return this.excRest.sput(this.excRest.computeUrl('TaskU_ContactAttempt', {vorgID: data.vorgID, auID: dataCase.auID})
        , requestData, 'ContactAttempt-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Kontaktaufnahmeversuch protokolliert', 'md-toast', 'fal fa-check');
          }
          return response;
        }));
    },
    DispoToMe: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKDISPO2ME')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang an sich selbst zu disponieren', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('Task_WFDispoToMe', {vorgID: data.vorgID})
        , data, 'DispoToMe-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang an Sie selbst disponiert', 'md-toast', 'fal fa-check');
          }
        }));
    },
    ChangeEditor: (data: any, oeIDEditor: string): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKDISPO')) {
        this.modal.showToast('Sie sind nicht berechtigt den Bearbeiter zu ändern', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.put(this.excRest.computeUrl('TaskU_Editor', {vorgID: data.vorgID, oeID: oeIDEditor})
        , {VorgUPT: data.vorgUPT})
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Bearbeiter des Vorgangs wurde geändert', 'md-toast', 'fal fa-check');
          }
        }));
    },
    Edit: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKEDIT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang anzunehmen.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('TaskU_Edit', {vorgID: data.vorgID})
        , data, 'TaskU_Edit-' + data.vorgID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang wurde angenommen', 'md-toast', 'fal fa-check');
          }
          return response;
        }));
    },
    ManualStateChange: (data: any, enmIdent: number, comment: string): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKSTATCHANGE')) {
        this.modal.showToast('Sie sind nicht berechtigt den Status manuell zu ändern', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(
        this.excRest.computeUrl('TaskU_StateManual', {vorgID: data.vorgID})
        , {VorgUPT: data.vorgUPT, vorg_enmIdent_VorgangStatus: enmIdent, vorg_stateChangeComment: comment}
        , 'TaskStateManually-' + data.vorgID
      ).pipe(
        map(response => {
          if (response && response.success) {
            this.modal.showToast('Status wurde erfolgreich geändert', 'md-toast', 'fal fa-check');
          }
          else {
            this.modal.showToast(
              this.getRessource('Statusänderung fehlgeschlagen')
              , 'md-toast', 'fas fa-exclamation');
          }
        })
      );
    },
    Create: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('TASKCREATE')) {
        this.modal.showToast('Sie sind nicht berechtigt den Vorgang anzulegen', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.post(
        this.excRest.computeUrl('TaskC', {})
        , data
      ).pipe(
        map(response => {
          if (response && response.success) {
            this.modal.showToast('Vorgang wurde erfolgreich angelegt', 'md-toast', 'fal fa-check');
          }
          else {
            this.modal.showToast(
              'Vorgangsanlage fehlgeschlagen'
              , 'md-toast', 'fas fa-exclamation');
          }
        })
      );
    }
  };

  constructor(private excRest: ExcRestService, private modal: ExgModalService, private excSecurity: ExcSecurityService) {
    super();
  }
}

